import { TypedUseSelectorHook, useSelector as reactReduxUseSelector } from 'react-redux';

import { LeadPlatformStore } from '../ReduxStore/types';

export const useSelector: TypedUseSelectorHook<LeadPlatformStore> = reactReduxUseSelector;
